import { useLocation, useNavigate } from "react-router-dom";

import useUser from "../../profile/useUser";
import { PRIMARY_NAV, accountNav, isNavActive } from "../navItems";

const MobileNav = ({ open, onClose, onLogout }) => {
  const navigate = useNavigate();
  const { pathname } = useLocation();
  const { isAuthenticated } = useUser();

  const items = [
    ...PRIMARY_NAV.filter((item) => !item.auth || isAuthenticated),
    ...(isAuthenticated ? accountNav() : []),
  ];

  const activate = (item) => {
    onClose();

    if (item.action === "logout") return onLogout();
    if (item.href) return window.open(item.href);

    navigate(item.path);
  };

  return (
    <div className={`sy-mobile-nav${open ? " is-open" : ""}`} hidden={!open}>
      <nav className="sy-mobile-section" aria-label="Sections">
        {items.map((item) => (
          <button
            type="button"
            key={item.key}
            className={`sy-mobile-link${isNavActive(item, pathname) ? " is-active" : ""}${
              item.action === "logout" ? " sy-mobile-link--logout" : ""
            }`}
            onClick={() => activate(item)}
          >
            {item.label}
          </button>
        ))}

        {!isAuthenticated && (
          <button
            type="button"
            className="sy-mobile-link"
            onClick={() => {
              onClose();
              navigate("/auth");
            }}
          >
            Sign In | Up
          </button>
        )}
      </nav>
    </div>
  );
};

export default MobileNav;
